import ApplePromotionRow from './index';
import type { SnowplowClickoutContext } from '@/helpers/tracking/providers/snowplow-contexts';

const property = 'offer' as const;

export const applePromotionRowTrackImpression = () => ApplePromotionRow.trackEvent({ action: 'impression', property });

export const applePromotionRowTrackCTAClick = (contexts: SnowplowClickoutContext[]) =>
	ApplePromotionRow.trackEvent({
		action: 'click',
		label: 'start_trial_clicked',
		property,
		contexts,
	});

export const applePromotionRowTrackPosterRowClick = (contexts: SnowplowClickoutContext[]) =>
	ApplePromotionRow.trackEvent({
		action: 'click',
		label: 'poster_row_clicked',
		property,
		contexts,
	});

export const applePromotionRowTrackNotifyMeClick = () =>
	ApplePromotionRow.trackEvent({
		action: 'click',
		label: 'notify_me_clicked',
		property,
	});

export const applePromotionRowTrackFreeOfferClick = (contexts: SnowplowClickoutContext[]) =>
	ApplePromotionRow.trackEvent({
		action: 'click',
		label: 'free_clickout',
		property,
		contexts,
	});

export const applePromotionRowTrackRegularOfferClick = (contexts: SnowplowClickoutContext[]) =>
	ApplePromotionRow.trackEvent({
		action: 'click',
		label: 'regular_clickout',
		property,
		contexts,
	});
